import type { AuditEntryDto } from '@lunary/api-client'
import { EntryDetails } from './entry-details'
import { SECTION_LABELS, actionLabel } from './labels'
import styles from './audit-log.module.css'

type Props = {
  readonly entry: AuditEntryDto
  readonly open: boolean
  readonly onToggle: () => void
}

const TIME = new Intl.DateTimeFormat('ru-RU', { timeZone: 'Europe/Moscow', hour: '2-digit', minute: '2-digit' })

function resultBadge(entry: AuditEntryDto) {
  if (entry.kind === 'error') {
    return <span className={`badge ${entry.status >= 500 ? 'danger' : styles.warn}`}>{entry.status >= 500 ? 'сбой' : 'ошибка'}</span>
  }
  if (entry.method === 'DELETE') return <span className="badge">удалено</span>
  if (entry.method === 'POST' && !entry.changes.some((c) => c.from !== null)) return <span className="badge ok">создано</span>
  return <span className={`badge ${styles.changed}`}>изменено</span>
}

export function EntryRow({ entry, open, onToggle }: Props) {
  const name = entry.actor_name ?? 'Без имени'
  const object = entry.entity_label ?? entry.entity_id
  const section = SECTION_LABELS[entry.entity_type] ?? entry.entity_type
  return (
    <>
      <button type="button" className={styles.entry} aria-expanded={open} onClick={onToggle}>
        <span className={styles.time}>{TIME.format(new Date(entry.created_at))}</span>
        <span className={entry.actor_role === 'admin' ? `${styles.who} ${styles.whoAdmin}` : styles.who} aria-hidden="true">
          {name.slice(0, 1).toUpperCase()}
        </span>
        <span className={styles.text}>
          <b>{name}</b> · {actionLabel(entry.method, entry.route)}
          <span className={styles.sub}>
            {section}
            {object ? ` · ${object}` : ''}
            {entry.kind === 'error' && entry.error_code ? ` · ${entry.status} ${entry.error_code}` : ''}
          </span>
        </span>
        <span className={styles.badges}>{resultBadge(entry)}</span>
      </button>
      {open && <EntryDetails entry={entry} />}
    </>
  )
}
